import { AztecProduct } from 'types/models';
import { calculateLinePrice, getSelectedPortion } from 'menu/utils';
import { CustomFormattedNumber } from 'common/components/CustomFormattedNumber';
import { useConfig } from 'contexts/ConfigContext';

interface ConfirmButtonTotalProps {
  aztecProduct: AztecProduct;
}
export const ConfirmButtonTotal: React.FC<ConfirmButtonTotalProps> = ({
  aztecProduct,
}) => {
  const { currencySymbolsDisabled, currency } = useConfig();
  const selectedPortion = getSelectedPortion(aztecProduct);

  const linePrice = calculateLinePrice(aztecProduct);
  const totalPrice = linePrice * (selectedPortion?.quantity ?? 0);

  return (
    <>
      {' ('}
      <CustomFormattedNumber
        style={currencySymbolsDisabled ? 'decimal' : 'currency'}
        value={totalPrice}
        currency={currency}
        hideZeroValue={false}
        minimumFractionDigits={2}
      />
      {')'}
    </>
  );
};
